

export enum BrowserTypes {
    Edge = "Edge",
    Chrome = "Chrome",
    Safari = "Safari",
    Other = "Other"
}

export const getBrowserName = (): BrowserTypes => {
  const userAgent = navigator.userAgent;

  if (userAgent.includes("Edg/")) return BrowserTypes.Edge;
  if (userAgent.includes("Chrome/") && !userAgent.includes("Edg/")) return BrowserTypes.Chrome;
  if (userAgent.includes("Safari/") && !userAgent.includes("Chrome/")) return BrowserTypes.Safari;
  return BrowserTypes.Other;
}


export const isIOS = () =>
  /iPad|iPhone|iPod/.test(navigator.userAgent) ||
  // iPadOS 13+ маскируется под Mac
  (navigator.platform === 'MacIntel' && (navigator as any).maxTouchPoints > 1);

export const isAndroid = () => /Android/i.test(navigator.userAgent);
